module.exports = __webpack_public_path__ + "img/jingxi.45c613ed.png";